import { html } from 'lit';
import { ThumbsDown } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-thumbs-down')
export class PdsIconThumbsDown extends PdsIcon {
  @state()
  icon = ThumbsDown;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
